<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<mat-drawer-container class="container">
  @if (sideNavCollapsed) {
  <mat-drawer #sidenav mode="side" opened class="side-nav-collapsed">
    <div class="top-div">
      <a mat-icon-button [routerLink]="['/build/']" title="Back to My MSELs">
        <mat-icon class="mat-list-item-icon mdi-24px" fontIcon="mdi-arrow-left-thin-circle-outline"></mat-icon>
      </a>
    </div>
    <mat-list class="list-container">
      <mat-divider></mat-divider>
      @for (tabName of getTabListItems(); track tabName) {
      <mat-list-item [ngClass]="getListItemClass(tabName)" (click)="tabChange(tabName)" title="{{ tabName }}">
        <mat-icon class="mat-list-item-icon mdi-24px" fontIcon="{{ fontIconList.get(tabName) }}"></mat-icon>
      </mat-list-item>
      }
    </mat-list>
    <div class="bottom-div">
      @if (canAccessAdminSection) {
      <button mat-icon-button title="Administration" (click)="goToUrl('/admin')">
        <mat-icon class="mdi-24px" fontIcon="mdi-cog-outline"></mat-icon>
      </button>
      }
      <button mat-icon-button title="Expand Navigation Panel" (click)="setCollapsed(false)">
        <mat-icon aria-hidden="false" class="mat-list-item-icon" fontIcon="mdi-chevron-double-right"></mat-icon>
      </button>
      <img class="crucible-logo" [src]="
                      (theme$ | async) === 'light-theme'
            ? 'assets/img/crucible-app-color-white.png'
            : 'assets/img/crucible-app-color.png'
        " />
    </div>
  </mat-drawer>
  }
  @if (!sideNavCollapsed) {
  <mat-drawer #sidenav mode="side" opened class="side-nav">
    <a class="top-div" [routerLink]="['/build/']" title="Back to My MSELs">
      <div class="one-cell center-self">
        <mat-icon class="mat-list-item-icon mdi-24px" fontIcon="mdi-arrow-left-thin-circle-outline"></mat-icon>
      </div>
      @if (!sideNavCollapsed) {
      <div class="five-cell center-self">
        back to My MSELs
      </div>
      }
    </a>
    <mat-list class="list-container">
      <mat-divider></mat-divider>
      @for (tabName of getTabListItems(); track tabName) {
      <mat-list-item [ngClass]="getListItemClass(tabName)" (click)="tabChange(tabName)">
        <div [ngClass]="getListItemClass(tabName)">
          <div class="one-cell center-self">
            <mat-icon class="mat-list-item-icon mdi-24px" fontIcon="{{ fontIconList.get(tabName) }}"></mat-icon>
          </div>
          @if (!sideNavCollapsed) {
          <div class="four-cell center-self">
            {{ tabName }}
          </div>
          <div class="one-cell center-self">
            <mat-icon class="mat-list-item-icon" fontIcon="mdi-chevron-right"></mat-icon>
          </div>
          }
        </div>
      </mat-list-item>
      }
    </mat-list>
    @if (!sideNavCollapsed) {
    <div class="bottom-div">
      <div class="admin-and-collapse">
        <div class="admin-section">
          @if (canAccessAdminSection) {
          <button mat-icon-button title="Administration" (click)="goToUrl('/admin')">
            <mat-icon class="mdi-24px" fontIcon="mdi-cog-outline"></mat-icon>
          </button>
          }&nbsp;
        </div>
        <div class="collapse-section">
          <button mat-icon-button title="Collapse Navigation Panel" (click)="setCollapsed(true)">
            <mat-icon aria-hidden="false" class="mdi-24px" fontIcon="mdi-chevron-double-left"></mat-icon>
          </button>
        </div>
      </div>
      <img class="crucible-logo" [src]="
                      (theme$ | async) === 'light-theme'
            ? 'assets/img/crucible-logo-light.png'
            : 'assets/img/crucible-logo-dark.png'
        " />
    </div>
    } @else {
    <div class="bottom-div">
      @if (canAccessAdminSection) {
      <button mat-icon-button title="Administration" (click)="goToUrl('/admin')">
        <mat-icon class="mdi-24px" fontIcon="mdi-cog-outline"></mat-icon>
      </button>
      }
      <button mat-icon-button title="Expand Navigation Panel" (click)="setCollapsed(false)">
        <mat-icon aria-hidden="false" class="mat-list-item-icon" fontIcon="mdi-chevron-double-right"></mat-icon>
      </button>
    </div>
    }
  </mat-drawer>
  }
  <mat-drawer-content class="content-frame">
    <div class="main-content">
      @if (selectedTab === 'Info') {
      <app-msel-info [loggedInUserId]="loggedInUserId" (deleteThisMsel)="deleteMsel($event)"></app-msel-info>
      }
      @if (selectedTab === 'Contributors') {
      <app-msel-contributors [loggedInUserId]="loggedInUserId"></app-msel-contributors>
      }
      @if (selectedTab === 'Teams') {
      <app-msel-teams [loggedInUserId]="loggedInUserId"></app-msel-teams>
      }
      @if (selectedTab === 'Data Fields') {
      <app-data-field-list [loggedInUserId]="loggedInUserId" [showTemplates]="false"
        [userTheme]="userTheme$ | async"></app-data-field-list>
      }
      @if (selectedTab === 'Organizations') {
      <app-organization-list [loggedInUserId]="loggedInUserId" [canEdit]="canEditMsel"
        [showTemplates]="false">Organizations</app-organization-list>
      }
      @if (selectedTab === 'Moves') {
      <app-move-list [loggedInUserId]="loggedInUserId" [canEditMsel]="canEditMsel"></app-move-list>
      }
      @if (selectedTab === 'Player Apps') {
      <app-player-application-list [loggedInUserId]="loggedInUserId"></app-player-application-list>
      }
      @if (selectedTab === 'Gallery Cards') {
      <app-card-list [loggedInUserId]="loggedInUserId" [canEdit]="canEditMsel" [showTemplates]="false"></app-card-list>
      }
      @if (selectedTab === 'CITE Actions') {
      <app-cite-action-list [loggedInUserId]="loggedInUserId" [canEdit]="canEditMsel"></app-cite-action-list>
      }
      @if (selectedTab === 'CITE Duties') {
      <app-cite-duty-list [loggedInUserId]="loggedInUserId" [canEdit]="canEditMsel"></app-cite-duty-list>
      }
      @if (selectedTab === 'Scenario Events') {
      <app-scenario-event-list [loggedInUserId]="loggedInUserId"
        [userTheme]="userTheme$ | async"></app-scenario-event-list>
      }
      @if (selectedTab === 'Exercise View') {
      <app-msel-view [tabHeight]="48" [userTheme]="userTheme$ | async"></app-msel-view>
      }
      @if (selectedTab === 'Invitations') {
      <app-invitation-list [loggedInUserId]="loggedInUserId" [canEditMsel]="canEditMsel"
        [hideSearch]="false">Invitations</app-invitation-list>
      }
      @if (selectedTab === 'MSEL Playbook') {
      <app-msel-playbook [loggedInUserId]="loggedInUserId" [canEditMsel]="canEditMsel"></app-msel-playbook>
      }
    </div>
  </mat-drawer-content>
</mat-drawer-container>
